/** Regra de senha do app — espelha `_validate_strong_password` do backend. */
export const PASSWORD_POLICY_MESSAGE =
  'A senha deve ter no mínimo 6 caracteres, com pelo menos uma letra maiúscula e um número.';

const PASSWORD_MIN_LENGTH = 6;

export const meetsPasswordPolicy = (password: string): boolean =>
  password.length >= PASSWORD_MIN_LENGTH && /[A-Z]/.test(password) && /\d/.test(password);
